import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AcabimProject, AcabimSite, MapViewerComponent, SiteApiService} from '@cas-hub/acabim-common-client';

@Component({
    selector: 'acabim-admin-project-details',
    templateUrl: './project-details.component.html',
    styleUrls: ['./project-details.component.scss']
})
export class ProjectDetailsComponent implements OnInit {

    @Input() project?: AcabimProject;
    private _mapView?: MapViewerComponent;

    public mapCoordinates?: number[][];
    currentSite?: AcabimSite;

    @ViewChild('mapViewer', {static: false})
    public set mapView(content: MapViewerComponent | undefined) {
        this._mapView = content;
    }

    public get mapView(): MapViewerComponent | undefined {
        return this._mapView;
    }

    constructor(private readonly siteApiService: SiteApiService) {
    }

    private refreshMap(): void {
        if (!this.currentSite) {
            return;
        }

        this.mapCoordinates = this.currentSite?.coordinates;
        if (this.mapView) {
            this.mapView.path = this.mapCoordinates;
            if (this.currentSite?.address) {
                this.mapView.locationTitle = this.currentSite.address;
                this.mapView.mapConfig = {
                    zoom: 16,
                    centerLongitude: this.currentSite.longitude,
                    centerLatitude: this.currentSite.latitude
                };
            }
            this.mapView.refreshMapView().then(r => {
            });
        }

    }


    ngOnInit(): void {
        if (this.project?.site?.id) {
            this.siteApiService.getSite(this.project?.site.id, {
                includeCoordinates: true,
                includeProjects: false,
                includeGroups: false
            }).subscribe(site =>{
              this.currentSite = site;
              this.refreshMap();
            });
        }
    }


}
